<template>
  <v-container
    id="productTemplateSectionEdit"
    class="pa-0"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <v-text-field
          v-model="editedItem.templateSection"
          :error-messages="safeFormErrors.TemplateSection"
          label="Section"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="editedItem.answerMulti"
          :error-messages="safeFormErrors.AnswerMulti"
          label="Multiple"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="editedItem.orderNo"
          :error-messages="safeFormErrors.OrderNo"
          label="Order"
          type="number"
          @change="onChange"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'ProductTemplateSectionEdit',

    props: {
      value: {
        type: Object,
        default: null,
      },
      formErrors: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      editedItem: null,
    }),

    computed: {
      safeFormErrors () {
        return this.formErrors || {}
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.editedItem = (this.value || {})
      },

      onChange () {
        this.$emit('update:value', this.editedItem)
        this.$emit('change', this.editedItem)
      },
    },
  }
</script>
